/**
 * Re-enables the footer's sticky-reveal effect on mobile only when the
 * footer actually fits the viewport (CSS defaults it to `static` there,
 * since a taller footer would otherwise clip above the fold, unreachable).
 */
const MOBILE_QUERY = "(max-width: 767.98px)";
const MOTION_QUERY = "(prefers-reduced-motion: reduce)";
const FITS_CLASS = "footer-reveal--fits";

function update() {
  const reveal = document.querySelector(".footer-reveal");
  if (!reveal) return;

  const isMobile = window.matchMedia(MOBILE_QUERY).matches;
  const reducedMotion = window.matchMedia(MOTION_QUERY).matches;
  // offsetHeight holds regardless of position mode, so this works whether or not the reveal is engaged.
  const fits = reveal.offsetHeight <= window.innerHeight;

  reveal.classList.toggle(FITS_CLASS, isMobile && !reducedMotion && fits);
}

let queued = false;
function schedule() {
  if (queued) return;
  queued = true;
  requestAnimationFrame(() => {
    queued = false;
    update();
  });
}

schedule();
window.addEventListener("resize", schedule, { passive: true });
window.addEventListener("orientationchange", schedule, { passive: true });
window.addEventListener("load", schedule, { once: true });
document.addEventListener("shopify:section:load", schedule);
document.addEventListener("shopify:section:unload", schedule);
window.matchMedia(MOTION_QUERY).addEventListener?.("change", schedule);
